import { MultiPolygonWithHoles, PolygonWithHoles, SimpleBoundingBox } from "@nova/constants"
import { Coordinate } from "@nova/protobuf"

export function getPolygonBounds(polygon: PolygonWithHoles) {
    const longitudes = polygon.outer.map((point) => point.longitude)
    const latitudes = polygon.outer.map((point) => point.latitude)
    return {
        minLng: Math.min(...longitudes),
        maxLng: Math.max(...longitudes),
        minLat: Math.min(...latitudes),
        maxLat: Math.max(...latitudes),
    }
}

export function getMultiPolygonBounds(multiPolygon: MultiPolygonWithHoles) {
    const boxes = multiPolygon.map(getPolygonBounds)
    return {
        minLng: Math.min(...boxes.map((box) => box.minLng)),
        maxLng: Math.max(...boxes.map((box) => box.maxLng)),
        minLat: Math.min(...boxes.map((box) => box.minLat)),
        maxLat: Math.max(...boxes.map((box) => box.maxLat)),
    }
}

export function boundsIntersect(a: SimpleBoundingBox, b: SimpleBoundingBox) {
    return (
        a.minLng <= b.maxLng && a.maxLng >= b.minLng && a.minLat <= b.maxLat && a.maxLat >= b.minLat
    )
}

export function pointInBounds(point: Coordinate, bounds: SimpleBoundingBox) {
    return (
        point.longitude >= bounds.minLng &&
        point.longitude <= bounds.maxLng &&
        point.latitude >= bounds.minLat &&
        point.latitude <= bounds.maxLat
    )
}
